class Category {
  id;
  name;
  image;
  starsNumber;
  creatorOfCategory;
  creationDate;

  constructor(data) {
    this.init(data);
  }

  init(data) {
    const { id, name, image, starsNumber, creatorOfCategory, creationDate } =
      data;

    if (
      !id ||
      !name ||
      !image ||
      !starsNumber ||
      !creatorOfCategory ||
      !creationDate
    )
      throw new Error("Invalid category data");

    this.id = id;
    this.name = name;
    this.image = image;
    this.starsNumber = starsNumber;
    this.creatorOfCategory = creatorOfCategory;
    this.creationDate = creationDate;
  }

  //some getters
  get getId() {
    return this.id;
  }

  get getName() {
    return this.name;
  }

  get getImage() {
    return this.image;
  }

  get getStarsNumber() {
    return this.starsNumber;
  }

  get getCreatorOfCategory() {
    return this.creatorOfCategory;
  }

  get getCreationDate() {
    return this.creationDate;
  }

  //somes methods
  update(data) {
    const { name, image, starsNumber } = data;

    this.name = name ? name : this.name;
    this.image = image ? image : this.image;
    this.starsNumber = starsNumber ? starsNumber : this.starsNumber;
  }
}

export default Category;
